module.exports = __webpack_public_path__ + "c21706c4c7ce0b835f81ae61fc3fd796.pdf";